import swaggerClient from "./../plugins/swagger-client";

export default class GroupService {
  createGroup(payload) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.createGroup(
          {},
          swaggerClient.buildRequestBody(payload),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }

  retrieveGroup(groupId) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.retrieveGroup(
          { groupId },
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }

  retrieveGroupByClient(clientId) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.retrieveGroupByClient(
          { clientId },
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }

  updateGroup(groupId, payload) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.updateGroup(
          { groupId },
          swaggerClient.buildRequestBody(payload),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }

  deleteGroup(groupId) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.deleteGroup(
          { groupId },
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }

  addMemberToGroup(groupId, payload) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.addMemberToGroup(
          { groupId },
          swaggerClient.buildRequestBody(payload),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }

  removeMemberFromGroup(groupId, payload) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.groups.removeMemberFromGroup(
          { groupId },
          swaggerClient.buildRequestBody(payload),
          {}
        );
      })
      .then(response => response.body)
      .catch(error => Promise.reject(error));
  }
}
